import { isEnvironmentLocal, isEnvironmentProduction, isEnvironmentStaging } from '@/Environment';

/**
 * @param path on the marketing site, like `privacy-policy`
 * @returns a link to the marketing host + path.
 */
export function getMarketingUrl(path = ''): string {
  const pathWithPrefix = path.startsWith('/') ? path : `/${path}`;
  if (isEnvironmentLocal()) {
    return `https://test-color-genomics.pantheonsite.io${pathWithPrefix}`;
  }
  if (isEnvironmentStaging()) {
    return `https://test-color-genomics.pantheonsite.io${pathWithPrefix}`;
  }
  if (isEnvironmentProduction()) {
    return `https://www.color.com${pathWithPrefix}`;
  }
  return `https://test-color-genomics.pantheonsite.io${pathWithPrefix}`;
}
